import QualifierManagement from '../../components/qualifiers/QualifierManagement';
import styles from "../Configurations.module.css";

const QASettings = () => {
    return (
        <div className={styles.section}>
            <h2>QA Settings</h2>
            <p>Quality Assurance configurations and parameters</p>

            <div className={styles.tabContainer}>
                <div className={styles.tabContent}>
                    <QualifierManagement />
                </div>
            </div>
        </div>
    );
};

export default QASettings;
